<template lang="pug">
.form-wrapper
  form(action="#", v-on:submit.prevent="submitForm(endpoint)")
    h4 {{formHeader}}
    slot
    ed-button(:class="submitClass", type="submit") {{submitText}}
</template>

<script>

import api from '@/core/api'

export default {
  name: 'ed-form',
  props: {
    formHeader: String,
    submitClass: {
      type: String,
      default: 'btn btn-primary'
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    endpoint: String
  },
  methods: {
    submitForm: (endpoint) => {
      api.post(api.$[endpoint] /*, data */)
        .then((res) => {
        })
        .catch((err) => console.error(err))
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

</style>



// WEBPACK FOOTER //
// index.vue?9b7cd398